import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http'

export const isPaymentRequired = (error: any) =>
  error instanceof HttpErrorResponse && error.status === HttpStatusCode.PaymentRequired
